import script from "./ExpandTransition.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpandTransition.vue?vue&type=script&setup=true&lang=js"

import "./ExpandTransition.vue?vue&type=style&index=0&id=54b7d6a8&lang=postcss&scoped=true"
script.__scopeId = "data-v-54b7d6a8"

export default script